import React from "react";
import {
    List,
    Datagrid,
    TextField,
    DateField,
    Show,
    SimpleShowLayout,
    FunctionField,
} from "react-admin";

const JsonBlock = ({ value }) => (
    <pre
        style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            background: "#f6f6f6",
            padding: "12px",
            borderRadius: "8px",
            fontSize: "13px",
            lineHeight: 1.4,
        }}
    >
        {JSON.stringify(value ?? {}, null, 2)}
    </pre>
);

export const UserProfileAuditLogList = () => (
    <List
        perPage={25}
        sort={{ field: "created_at", order: "DESC" }}
        title="Изменения профилей"
    >
        <Datagrid rowClick="show" bulkActionButtons={false}>
            <DateField source="created_at" label="Дата" showTime />
            <TextField source="target_username_snapshot" label="Кому изменили" />
            <TextField source="changed_by_username_snapshot" label="Кто изменил" />
            <TextField source="changed_by_role" label="Роль" />
            <TextField source="field_name" label="Поле" />
            <TextField source="change_type" label="Тип" />
        </Datagrid>
    </List>
);

export const UserProfileAuditLogShow = () => (
    <Show title="Изменение профиля">
        <SimpleShowLayout>
            <DateField source="created_at" label="Дата" showTime />

            <TextField source="target_username_snapshot" label="Кому изменили" />
            <TextField source="changed_by_username_snapshot" label="Кто изменил" />
            <TextField source="changed_by_role" label="Роль изменившего" />

            <TextField source="field_name" label="Поле" />
            <TextField source="change_type" label="Тип изменения" />

            <FunctionField
                label="Было"
                render={(record) => <JsonBlock value={record?.old_value_json} />}
            />

            <FunctionField
                label="Стало"
                render={(record) => <JsonBlock value={record?.new_value_json} />}
            />
        </SimpleShowLayout>
    </Show>
);